var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.twitterUsername)?_c('div',[_c('a',{staticClass:"twitter-timeline",attrs:{"height":_vm.height,"href":("https://twitter.com/" + _vm.twitterUsername)}},[_vm._v("Tweets by "+_vm._s(_vm.twitterUsername))])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }